<template>
  <div-unit unitTitle="Dynamic change in research focus of drug modalities for" :customHTML="dis_value_show"
    v-loading="checkData">
    <div id="drugType-byDrug" class="half-big-plot">
      <div style="height: 550px;">
        <BaseECharts :option="chartOption.byDrug" />
      </div>
      <NewDataNote></NewDataNote>
    </div>
    <hr>
    <div id="drug-type-byNCT" class="half-big-plot">
      <div style="height: 550px;">
        <BaseECharts :option="chartOption.byNCT" /></div>
    <NewDataNote></NewDataNote>
    </div>
  </div-unit>
</template>
<script>
import _ from "lodash";
import api from "@/api/index";
import DivUnit from "@/components/DivUnit.vue";
import BaseECharts from "@/components/BaseECharts.vue";
import NewDataNote from "@/components/NewDataNote.vue";
export default {
  data() {
    return {
      plotDataByDrug: {},
      plotDataByNCT: {},
      checkData: true,
    };
  },
  props: {
    dis_value_show: {
      type: String,
      required: true,
    },
    dis_value: {
      type: String,
      required: true,
    },
  },

  components: {
    BaseECharts,
    DivUnit, NewDataNote
  },

  computed: {
    graphByDrug() {
      if (this.plotDataByDrug && this.plotDataByDrug[this.dis_value]) {
        return this.plotDataByDrug[this.dis_value];
      }
      return {};
    },
    graphByNCT() {
      if (this.plotDataByNCT && this.plotDataByNCT[this.dis_value]) {
        return this.plotDataByNCT[this.dis_value];
      }
      return {};
    },

    chartOption() {
      if (
        !("time_window" in this.graphByDrug) ||
        !("time_window" in this.graphByNCT)
      ) {
        return {
          byDrug: {},
          byNCT: {},
        };
      }
      const baseOption = {
        textStyle: {
          fontFamily: "Harding",
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        title: {
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          enterable: true,
          confine: true,
          formatter: (params) => {
            let htmlStr = "";
            params.forEach((param, i) => {
              const xName = param.name;
              const seriesName = param.seriesName;
              const value = param.value;
              const color =
                param.color instanceof Object
                  ? param.color.colorStops[0].color
                  : param.color;

              if (i === 0) {
                htmlStr += `<div style="font-size:14px;color:#666;font-weight:400;line-height:1;">${xName}</div>`;
              }
              htmlStr += `
              <div style="margin:6px 0 0;line-height:1;">
                <div style="margin:6px 0 0;line-height:1;">
                  <span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>
                  <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">${seriesName}</span>
                  <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">
                    ${(parseFloat(value) + 0.002).toFixed(1)}%
                  </span>
                  <div style="clear:both"></div>
                </div>
                <div style="clear:both"></div>
              </div>`;
            });
            return htmlStr;
          },
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          top: "18%",
          left: "3%",
          right: "3%",
          bottom: "7%",
          containLabel: true,
        },
        
        legend: {
          itemGap: 50,
          top: "9%",
          selectedMode: false,
          textStyle: {
            fontSize: "16",
          },
          data: [
            "Small molecule drug",
            "Protein & peptide drug",
            "Antibody-related drug",
            "Other drug",
          ],
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          axisTick: {
            alignWithLabel: false,
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: "#000",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 40,
            textStyle: {
              color: "#000",
              fontSize: "18px",
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          min: 20,
          max: 100,
          nameGap: 55,
          name: "Percentage (%)",
          nameLocation: "center",
          nameTextStyle: {
            color: "#000",
            fontSize: "18px",
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: "#000",
            },
          },
          axisTick: {
            show: true,
          },
          axisLabel: {
            formatter: (params) => `${params}%`,
            color: "#000",
            textStyle: {
              fontSize: "18px",
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "Small molecule drug",
            type: "bar",
            barWidth: 35,
            stack: "total",
            label: { show: false, color: "black" },
            emphasis: { focus: "none" },
            // data: this.graph["Small molecule"],
            itemStyle: {
              borderRadius: 5,
              borderColor: "white",
              borderWidth: 0.5,
              // color: this.colorDist[this.divid][0],
            },
          },
          {
            name: "Protein & peptide drug",
            type: "bar",
            barWidth: 35,
            stack: "total",
            label: { show: false, color: "black" },
            emphasis: { focus: "none" },
            // data: this.graph["Protein/Peptide"],
            itemStyle: {
              borderRadius: 5,
              borderColor: "white",
              borderWidth: 0.5,
              // color: this.colorDist[this.divid][1],
            },
          },
          {
            name: "Antibody-related drug",
            type: "bar",
            barWidth: 35,
            stack: "total",
            label: { show: false, color: "black" },
            emphasis: { focus: "none" },
            // data: this.graph["Antibody/Antibody-drug conjugate"],
            itemStyle: {
              borderRadius: 5,
              borderColor: "white",
              borderWidth: 0.5,
              // color: this.colorDist[this.divid][2],
            },
          },
          {
            name: "Other drug",
            type: "bar",
            barWidth: 35,
            stack: "total",
            label: { show: false, color: "black" },
            emphasis: { focus: "none" },
            // data: this.graph["Others"],
            itemStyle: {
              borderRadius: 5,
              borderColor: "white",
              borderWidth: 0.5,
              // color: this.colorDist[this.divid][3],
            },
          },
        ],
      };

      const baseOptionByDrug = _.cloneDeep(baseOption);
      const baseOptionByNCT = _.cloneDeep(baseOption);
      baseOptionByDrug.title.text =
        "Change in the Focus of Drug Modalities Measured by Drugs";
      baseOptionByDrug.xAxis.data = this.graphByDrug.time_window;
      baseOptionByDrug.series.forEach((s, i) => {
        s.data =
          this.graphByDrug[
          [
            "Small molecule drug",
            "Protein & peptide drug",
            "Antibody-related drug",
            "Other drug",
          ][i]
          ];
      });
      ["#13acd8", "#6ac496", "#126271", "#d1c211"].forEach((color, i) => {
        baseOptionByDrug.series[i].itemStyle.color = color;
      });

      baseOptionByNCT.title.text =
        "Change in the Focus of Drug Modalities Measured by CDPs";
      baseOptionByNCT.xAxis.data = this.graphByNCT.time_window;
      baseOptionByNCT.series.forEach((s, i) => {
        s.data =
          this.graphByNCT[
          [
            "Small molecule drug",
            "Protein & peptide drug",
            "Antibody-related drug",
            "Other drug",
          ][i]
          ];
      });
      ["#448ae2", "#90cdec", "#a650bf", "#858bc5"].forEach((color, i) => {
        baseOptionByNCT.series[i].itemStyle.color = color;
      });
      return {
        byDrug: baseOptionByDrug,
        byNCT: baseOptionByNCT,
      };
    },
  },
  mounted() {
    api.getDrugType().then((res) => {
      this.plotDataByDrug = res.data.byDrug;
      this.plotDataByNCT = res.data.byNCT;
      this.checkData = false;
    });
  },
};
</script>


<style scoped>
hr {
  border: none;
  height: 3px;
  background: linear-gradient(to right, transparent, #5f75c2, transparent);
  margin: 30px 0;
}
.half-big-plot {
  height: 600px;
  width: 100%;
  padding-top: 10px;
  box-shadow: 1px 1px 4px 5px #e4e8f5;
  border-radius: 6px;
}
</style>